import { useContext, useMemo } from 'react'

import { ILocaleContext, IUseLocale, LocaleFallbackValue } from './types'

import LocaleContext from './Locale.Context'
import LocaleModule from './Module'

const useInterfaceLocale: IUseLocale = () => {
  const localeContext = useContext<ILocaleContext>(LocaleContext)
  return useMemo<ReturnType<IUseLocale>>(() => {
    function t<ValueType = string>(...path: string[]): ValueType {
      return LocaleModule.t(localeContext.interfaceLocaleID, path) as ValueType
    }
    function tf<ValueType = (n1: number, n2?: number) => string>(...path: string[]): ValueType {
      return LocaleModule.t(localeContext.interfaceLocaleID, path) as ValueType
    }
    function _t<ValueType = string>(fallbackValue: LocaleFallbackValue, ...path: string[]): ValueType {
      return LocaleModule.t(localeContext.interfaceLocaleID, path, fallbackValue) as ValueType
    }
    return {
      t,
      tf,
      _t,
      get localeID() {
        return localeContext.interfaceLocaleID
      },
      get languageTag() {
        return localeContext.interfaceLocaleID.replace('_', '-')
      },
      get localeOptions() {
        return LocaleModule.options(localeContext.interfaceLocaleID)
      }
    }
  }, [localeContext.interfaceLocaleID])
}

export default useInterfaceLocale
